import { Component } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { AppVersionService } from './shared/services/app-version';

@Component({
  selector: 'authority-labs-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private appVersionService: AppVersionService
  ) {
    this.appVersionService.start();
    this.matIconRegistry.addSvgIcon(
      '45deg',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/45_deg.svg')
    );
    this.matIconRegistry.addSvgIcon(
      '90deg',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/90_deg.svg')
    );
  }
}
